import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import ContestNamesSnippetNotFoundError from './contest-names-snippet-not-found-error';
import {contestNamesSnippetMap} from 'components/organisms/late-swap/services/maps';

const ContestNamesSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return contestNamesSnippetMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new ContestNamesSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default ContestNamesSnippetFactory;
